export enum Typology {
  intern = 'Interne',
  supplier = 'Fournisseur',
}
